import './index.scss';
import { useTranslation } from 'react-i18next';

export default AASTaxFilingEngagement; function AASTaxFilingEngagement({ TaxFilingQuestionnaire, HandleTaxFilingQuestionnaireSave }) {
    const { t } = useTranslation();
    const viewOnly = TaxFilingQuestionnaire?.Status?.toLowerCase() !== '' && TaxFilingQuestionnaire?.Status?.toLowerCase() !== 'new';

    const engagementOptions = [
        { value: 'Engage', label: t('Engage ACCLIME for U.S. Tax Filing Service') },
        { value: 'Not Engage', label: t('Do not engage ACCLIME for Tax Filing Service') },
    ];

    return (
        <div id='stepper-aas-tax-filing-engagement-div'>
            <div className='row tax-filing-questionnaire-title'>
                <p>{t('AAS TAX FILING ENGAGEMENT')}</p>
            </div>

            <div className='row aas-tax-filing-engagement-content'>
                <div className='col-md-12 row input-row'>
                    <div className='col-md-9'>
                        <p className='aas-tax-filing-engagement-description'>
                            {t('Would you like to engage ACCLIME Tax Advisory?')}
                        </p>
                    </div>
                </div>

                <div className='col-md-12 row input-row'>
                    <div className='col-md-9 aas-tax-filing-engagement-options'>
                        {engagementOptions.map((option) => (
                            <label
                                className={`aas-tax-filing-engagement-option${TaxFilingQuestionnaire?.AASEngagement === option.value ? ' is-selected' : ''}`}
                                key={option.value}
                            >
                                <input
                                    type='radio'
                                    name='AASEngagement'
                                    checked={TaxFilingQuestionnaire?.AASEngagement === option.value}
                                    onChange={() => HandleTaxFilingQuestionnaireSave('AASEngagement', option.value)}
                                    disabled={viewOnly}
                                />
                                <span>{option.label}</span>
                            </label>
                        ))}
                    </div>
                </div>

                {
                    TaxFilingQuestionnaire?.AASEngagement === 'Engage' && (<>
                        <div className='col-md-12 row input-row'>
                            <div className='col-md-9'>
                                <p className='aas-tax-filing-engagement-choice-note'>{t('I would like to proceed with the AAS tax filing service and complete the questionnaire.')}</p>
                            </div>
                        </div>
                    </>)
                }
                {
                    TaxFilingQuestionnaire?.AASEngagement === 'Not Engage' && (<>
                        <div className='col-md-12 row input-row'>
                            <div className='col-md-9'>
                                <p className='aas-tax-filing-engagement-choice-note'>{t('I do not wish to engage the AAS tax filing service for this tax year.')}</p>
                            </div>
                        </div>
                    </>)
                }

                {
                    TaxFilingQuestionnaire?.AASEngagement === 'Engage' && (<>
                        <div className='col-md-12 row input-row'>
                            <div className='col-md-9 tax-filing-questionnaire-notes'>
                                <svg
                                    className="svg-circle"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                >
                                    <path
                                        d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                        fill="#003448"
                                    />
                                </svg>
                                <svg
                                    className="svg-exclamation"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="2"
                                    height="10"
                                    viewBox="0 0 2 10"
                                    fill="none"
                                >
                                    <path
                                        d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                        fill="#003448"
                                    />
                                    <path
                                        d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                        fill="#003448"
                                    />
                                </svg>
                                <span><strong>{t('Cancellation Fee Notice')}:</strong> {t("By choosing to engage, you acknowledge that a cancellation fee may apply if you later choose not to proceed. The final terms are subject to Walton's tax filing agreement.")}</span>
                            </div>
                        </div>
                    </>)
                }
            </div>
        </div>
    );
};
